import { Injectable } from '@angular/core'
import { Title } from '@angular/platform-browser'
import {SwUpdate} from '@angular/service-worker'
import {Observable, Subject} from 'rxjs'
import { LocalStorageService } from './local-storage.service'

@Injectable({
  providedIn: 'root'
})
export class PwaService {

  private installEvent: Subject<any> = new Subject<any>()
  public $installEvent: Observable<any> = new Observable<any>()
  private manifestChanged: boolean = false
  private defaultLocale: string = 'en_US'

  constructor(
      private swUpdate: SwUpdate,
      private localStorageService: LocalStorageService,
      private titleService: Title
  ) {

    this.$installEvent = this.installEvent.asObservable()

    swUpdate.available.subscribe(event => {
      console.log('[SERVICE WORKER] Update available -> reload page')
      window.location.reload()
    })

    window.addEventListener('beforeinstallprompt', (event) => {
      if (!event || !this.manifestChanged) return
      console.log('[SERVICE WORKER] Install Event fired')
      this.installEvent.next(event)
    })
  }

  changeTitle(applicationId: string | null): void {
    if (applicationId) {
      let title: string = applicationId
      if (this.localStorageService.getSelectedQueue()?.name
        && this.localStorageService.getSelectedQueue()?.language?.length > 0
        && typeof (this.localStorageService.getSelectedQueue().name[this.localStorageService.getSelectedQueue().language]) !== 'undefined') {
        title = this.localStorageService.getSelectedQueue().name[this.localStorageService.getSelectedQueue().language]
      } else if (this.localStorageService.getSelectedQueue()?.name
        && this.localStorageService.getSelectedQueue().name[this.defaultLocale]) {
        title = this.localStorageService.getSelectedQueue().name[this.defaultLocale]
      }
      this.titleService.setTitle(title)
    }
  }

  changeManifest( applicationId: string | null ) {
    this.manifestChanged = true
    this.changeTitle(applicationId)
    const assetDir = window.location.href.split('/#/')[0]
    const myDynamicManifest = {
      'name': applicationId ? 'Lineberty ' + applicationId : 'Lineberty Endpoint',
      'short_name': applicationId ? 'Lineberty ' + applicationId : 'Lineberty Endpoint',
      'theme_color': '#0D47A1',
      'background_color': '#fafafa',
      'display': 'standalone',
      'scope': './',
      'start_url': window.location.origin + '/' + applicationId,
      'icons': [
        {
          'src': assetDir + '/' + 'assets/icons/icon-72x72.png',
          'sizes': '72x72',
          'type': 'image/png',
          'purpose': 'maskable any'
        },
        {
          'src': assetDir + '/' + 'assets/icons/icon-96x96.png',
          'sizes': '96x96',
          'type': 'image/png',
          'purpose': 'maskable any'
        },
        {
          'src': assetDir + '/' + 'assets/icons/icon-128x128.png',
          'sizes': '128x128',
          'type': 'image/png',
          'purpose': 'maskable any'
        },
        {
          'src': assetDir + '/' + 'assets/icons/icon-144x144.png',
          'sizes': '144x144',
          'type': 'image/png',
          'purpose': 'maskable any'
        },
        {
          'sizes': '152x152',
          'type': 'image/png',
          'purpose': 'maskable any'
        },
        {
          'src': assetDir + '/' + 'assets/icons/icon-192x192.png',
          'sizes': '192x192',
          'type': 'image/png',
          'purpose': 'maskable any'
        },
        {
          'src': assetDir + '/' + 'assets/icons/icon-384x384.png',
          'sizes': '384x384',
          'type': 'image/png',
          'purpose': 'maskable any'
        },
        {
          'src': assetDir + '/' + 'assets/icons/icon-512x512.png',
          'sizes': '512x512',
          'type': 'image/png',
          'purpose': 'maskable any'
        }
      ]
    }

    const stringManifest = JSON.stringify(myDynamicManifest)
    const blob = new Blob([stringManifest], {type: 'application/manifest+json'})
    const manifestURL = URL.createObjectURL(blob)
    document.querySelector('#global-manifest').setAttribute('href', manifestURL)
  }
}
